import { BaseTranslation } from 'src/i18n/i18n-types';

export const permissions: BaseTranslation = {
  delete: {
    modal: {
      title: 'Remove Permission',
      body: 'Are you sure you want to remove this permission?',
      teamSettingsTitle: 'Remove this user',
      teamSettingsBody:
        'Remove this user from your organisation. They will no longer have access to this workspace',
    },
  },
};
